import { render, staticRenderFns } from "./CompanyOrderAddEditView.vue?vue&type=template&id=b88ae7fa&scoped=true&"
import script from "./CompanyOrderAddEditView.vue?vue&type=script&lang=js&"
export * from "./CompanyOrderAddEditView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrderAddEditView.vue?vue&type=style&index=0&id=b88ae7fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88ae7fa",
  null
  
)

export default component.exports